import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { SalesTransactionsActions } from './sales-transactions.actions';
import { SalesTransactionService } from '../../services/sales-transaction.service';
import { extractErrorMessage } from '../../utils/error.utils';

@Injectable()
export class SalesTransactionsEffects {
  private actions$ = inject(Actions);
  private svc = inject(SalesTransactionService);

  loadAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SalesTransactionsActions.loadSalesTransactions),
      mergeMap(({ customerId }) => this.svc.getAll(customerId).pipe(
        map(transactions => SalesTransactionsActions.loadSalesTransactionsSuccess({ transactions })),
        catchError(err => of(SalesTransactionsActions.loadSalesTransactionsFailure({ error: err.message })))
      ))
    )
  );

  loadOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SalesTransactionsActions.loadSalesTransaction),
      mergeMap(({ id }) => this.svc.getById(id).pipe(
        map(transaction => SalesTransactionsActions.loadSalesTransactionSuccess({ transaction })),
        catchError(err => of(SalesTransactionsActions.loadSalesTransactionFailure({ error: err.message })))
      ))
    )
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SalesTransactionsActions.createSalesTransaction),
      mergeMap(({ dto }) => this.svc.create(dto).pipe(
        map(transaction => SalesTransactionsActions.createSalesTransactionSuccess({ transaction })),
        catchError(err => of(SalesTransactionsActions.createSalesTransactionFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SalesTransactionsActions.deleteSalesTransaction),
      mergeMap(({ id }) => this.svc.delete(id).pipe(
        map(() => SalesTransactionsActions.deleteSalesTransactionSuccess({ id })),
        catchError(err => of(SalesTransactionsActions.deleteSalesTransactionFailure({ error: err.message })))
      ))
    )
  );
}
